import React, { Component } from 'react'
import { List } from 'immutable'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as NotesSelectors } from 'data/notes'
import {
  actions as NoteActivitiesActions,
  selectors as NoteActivitiesSelectors,
  record as NoteActivityRecord,
} from 'data/noteActivities'
import { selectors as PaymentSelectors } from 'data/payment'
import { goToOrganizationUpgrade } from 'data/ui/actions'

import { Section, InfoTitle } from './Layout'
import ActivityItem from './ActivityItem'
import Statistics from './Statistics'
import { Text } from 'components/base'
import ModalBody from 'components/Utils/Modal/Body'
import IncentiveBox from 'components/Utils/IncentiveBox'

const MAX_FREE_ACTIVITES = 3

class NotesInfos extends Component {
  componentDidMount() {
    const { noteId, fetchNoteActivitiesWithContent } = this.props
    fetchNoteActivitiesWithContent({ noteId })
  }

  getCreationActivityRecord() {
    const { note } = this.props
    return new NoteActivityRecord({
      id: 'create',
      noteId: note.get('id'),
      createdAt: note.get('createdAt'),
      userIds: List([note.get('createdBy')]),
      type: 'create',
    })
  }

  render() {
    const { activities, note, isLimited, shouldDisplayUpgradeBox } = this.props
    return (
      <ModalBody>
        <Text.Title>Info about {note.get('title')}</Text.Title>
        <Section>
          <InfoTitle>Statistics</InfoTitle>
          <Statistics note={note} />
        </Section>
        <Section>
          <InfoTitle>Activity logs</InfoTitle>
          {activities
            .map(activity => (
              <ActivityItem key={activity.get('id')} activity={activity} />
            ))
            .slice(0, isLimited ? MAX_FREE_ACTIVITES : undefined)
            .toArray()}
          {((activities && activities.size < MAX_FREE_ACTIVITES) ||
            !isLimited) && (
            <ActivityItem activity={this.getCreationActivityRecord()} />
          )}
        </Section>
        {shouldDisplayUpgradeBox && (
          <Section>
            <IncentiveBox
              incentiveId="DisplayNotesActivity"
              className="margin-top-normal"
              extraItems={activities.size - MAX_FREE_ACTIVITES}
            />
          </Section>
        )}
      </ModalBody>
    )
  }
}

const mapStateToProps = (state, { noteId }) => {
  const note = NotesSelectors.getNote(state, noteId)
  const isLimited = PaymentSelectors.isLimited(state)
  const activities = NoteActivitiesSelectors.getNoteActivities(state, noteId)
  const shouldDisplayUpgradeBox = isLimited
  return {
    note,
    activities,
    isLimited,
    shouldDisplayUpgradeBox,
  }
}

const mapDispatchToProps = {
  ...NoteActivitiesActions,
  goToOrganizationUpgrade,
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(NotesInfos)
